/* Vantley PDP behaviour — mirrors the state machine in the Claude Design source
   (design-source/Vantley Product Page.dc.html): gallery, colour/size pickers,
   accordions, FAQ, review pager, size-guide modal, AJAX add-to-cart. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 860px)';
  var money = function (cents, fmt) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/, v);
  };

  /* ───────────── BUY SECTION ───────────── */
  function initBuy(root) {
    if (root.dataset.vtInit) return;
    root.dataset.vtInit = '1';

    var dataEl = root.querySelector('[data-vt-product-json]');
    var data = dataEl ? JSON.parse(dataEl.textContent) : null;

    /* gallery */
    var grid = root.querySelector('.pdp-gallery-grid');

    /* Which images belong to which colour is owned by the Rubik Variant Images
       app, not by this theme. It keeps an ordered list of media ids per option
       value in the product metafield craftshift.variantImages, which the buy
       section prints verbatim; we only read it. Re-ordering images in the app
       re-orders them here. */
    var rubikEl = root.querySelector('[data-vt-rubik]');
    var rubik = null;
    if (rubikEl) { try { rubik = JSON.parse(rubikEl.textContent); } catch (e) { rubik = null; } }

    var cells = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-vt-media]')) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.pdp-thumb[data-vt-media]'));
    var mainClass = cells.length && cells[0].classList.contains('pdp-gallery-cell--pad')
      ? 'pdp-gallery-cell--pad' : 'pdp-gallery-cell--fill';

    /* Ordered media ids the app assigned to this colour, or null when the
       colour has not been configured yet — then nothing is filtered, so an
       unconfigured colour shows the whole gallery instead of an empty one. */
    function rubikOrder(color) {
      if (!rubik || !rubik.values || !color) return null;
      var entry = null;
      for (var i = 0; i < rubik.values.length; i++) {
        if (String(rubik.values[i].n) === String(color)) { entry = rubik.values[i]; break; }
      }
      if (!entry || !entry.m || !entry.m.length) return null;
      var common = (rubik.common || []).map(String);
      return common.concat(entry.m.map(String));
    }

    function applyGallery(color) {
      if (!cells.length) return;
      var order = rubikOrder(color);
      var visible = [];

      cells.forEach(function (cell) {
        var id = String(cell.dataset.vtMedia);
        var pos = order ? order.indexOf(id) : -1;
        var show = order ? pos !== -1 : true;
        cell.style.display = show ? '' : 'none';
        cell.style.order = show && order ? pos : '';
        /* the first cell carries the large "main" treatment — hand it to
           whichever image the app ordered first */
        cell.classList.remove('pdp-gallery-cell--pad', 'pdp-gallery-cell--fill');
        cell.classList.add('pdp-gallery-cell--fill');
        if (show) visible.push({ el: cell, id: id, pos: order ? pos : visible.length });
      });

      visible.sort(function (a, b) { return a.pos - b.pos; });
      if (visible.length) {
        visible[0].el.classList.remove('pdp-gallery-cell--fill');
        visible[0].el.classList.add(mainClass);
      }

      thumbs.forEach(function (t) {
        var id = String(t.dataset.vtMedia);
        var pos = order ? order.indexOf(id) : -1;
        var show = order ? pos !== -1 : true;
        t.style.display = show ? '' : 'none';
        t.style.order = show && order ? pos : '';
      });

      return visible;
    }

    function visibleCells() {
      return cells.filter(function (c) { return c.style.display !== 'none'; })
                  .sort(function (a, b) {
                    return (parseInt(a.style.order, 10) || 0) - (parseInt(b.style.order, 10) || 0);
                  });
    }

    if (grid) {
      root.querySelectorAll('.pdp-gallery-arrow').forEach(function (btn) {
        btn.addEventListener('click', function () {
          grid.scrollBy({ left: (btn.classList.contains('pdp-gallery-next') ? 1 : -1) * grid.clientWidth, behavior: 'smooth' });
        });
      });
      root.querySelectorAll('[data-vt-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          /* thumbs are keyed by media id, so the target survives filtering */
          var idx = visibleCells().findIndex(function (c) {
            return String(c.dataset.vtMedia) === String(btn.dataset.vtThumb);
          });
          if (idx >= 0) grid.scrollTo({ left: idx * grid.clientWidth, behavior: 'smooth' });
        });
      });
    }

    /* option state */
    var firstTab = root.querySelector('[data-vt-gender]');
    var state = {
      color: root.dataset.vtInitialColor || null,
      size: null,
      gender: firstTab ? firstTab.dataset.vtGender : 'Women',
      added: false
    };
    var colorTiles = Array.prototype.slice.call(root.querySelectorAll('[data-vt-color]'));
    var sizePills = Array.prototype.slice.call(root.querySelectorAll('[data-vt-size]'));
    var genderTabs = Array.prototype.slice.call(root.querySelectorAll('[data-vt-gender]'));

    /* The banner section is a sibling of this one, not a descendant, so these
       are queried from the document rather than from root. Each colourway is a
       stacked layer inside .pdp-banner-media; we reveal the one whose name
       matches the selected colour. */
    var bannerLayers = Array.prototype.slice.call(
      document.querySelectorAll('.pdp-banner-media > .pdp-banner-layer'));

    function applyBanner(color) {
      if (!bannerLayers.length) return;
      var matched = null;
      bannerLayers.forEach(function (layer) {
        if (layer.hasAttribute('data-vt-banner-default')) return;
        var hit = !!color && layer.dataset.vtBannerColour === color;
        layer.hidden = !hit;
        if (hit) matched = layer;
      });
      /* Fall back to the default layer whenever the selected colour has no
         banner of its own, so the 21:9 box is never left empty. */
      bannerLayers.forEach(function (layer) {
        if (layer.hasAttribute('data-vt-banner-default')) layer.hidden = !!matched;
      });
      /* These layers load lazily, and a layer revealed for the first time would
         otherwise pop in a beat late. Nudging the freshly shown one to eager
         starts the fetch the moment the colour is picked. */
      if (matched) {
        var img = matched.querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
      }
    }
    var colorNameEl = root.querySelector('[data-vt-color-name]');
    var atc = root.querySelector('[data-vt-atc]');
    var atcText = root.querySelector('[data-vt-atc-label]');
    var priceEl = root.querySelector('[data-vt-price]');
    var idInput = root.querySelector('[data-vt-variant-id]');
    var form = root.querySelector('[data-vt-form]');

    /* the variant a size pill stands for under the current colour and gender */
    function pillVariant(size) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        if (data.colorIndex >= 0 && state.color !== null && v.options[data.colorIndex] !== state.color) continue;
        if (data.genderIndex >= 0 && v.options[data.genderIndex] !== state.gender) continue;
        if (v.options[data.sizeIndex] === size) return v;
      }
      return null;
    }
    function currentVariant() {
      if (!data || !data.variants) return null;
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        if (data.colorIndex >= 0 && state.color !== null && v.options[data.colorIndex] !== state.color) continue;
        if (data.genderIndex >= 0 && v.options[data.genderIndex] !== state.gender) continue;
        if (data.sizeIndex >= 0 && state.size !== null && v.options[data.sizeIndex] !== state.size) continue;
        if (data.sizeIndex >= 0 && state.size === null) continue;
        return v;
      }
      return null;
    }

    /* Bundle picker: offer cards, each pair with its own colour + size
       dropdowns. Pair #1 of the active card drives the gallery; the cart gets
       one line per pair and the automatic discount makes the second one free. */
    var bundle = root.querySelector('[data-vt-bundle]');
    var bundleCards = bundle ? Array.prototype.slice.call(bundle.querySelectorAll('[data-vt-offer]')) : [];

    function activeCard() {
      for (var i = 0; i < bundleCards.length; i++) {
        if (bundleCards[i].classList.contains('is-active')) return bundleCards[i];
      }
      return bundleCards[0] || null;
    }
    function cardRows(card) {
      return card ? Array.prototype.slice.call(card.querySelectorAll('[data-vt-pick]')) : [];
    }
    function findVariant(color, size) {
      if (!data || !data.variants || !size) return null;
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        if (v.options[data.colorIndex] === color && v.options[data.sizeIndex] === size) return v;
      }
      return null;
    }
    function rowVariant(row) {
      return findVariant(row.querySelector('[data-vt-pick-color]').value, row.querySelector('[data-vt-pick-size]').value);
    }
    function syncThumb(row) {
      var sel = row.querySelector('[data-vt-pick-color]');
      var thumb = row.querySelector('[data-vt-pick-thumb]');
      var opt = sel.options[sel.selectedIndex];
      var src = opt ? opt.getAttribute('data-thumb') : '';
      if (thumb) thumb.style.backgroundImage = src ? 'url("' + src + '")' : '';
    }
    function syncSizes(row) {
      /* a size sold out in this row's colour cannot be picked */
      var color = row.querySelector('[data-vt-pick-color]').value;
      var sizeSel = row.querySelector('[data-vt-pick-size]');
      Array.prototype.forEach.call(sizeSel.options, function (o) {
        if (!o.value) return;
        var v = findVariant(color, o.value);
        o.disabled = !v || !v.available;
      });
      if (sizeSel.selectedOptions[0] && sizeSel.selectedOptions[0].disabled) sizeSel.value = '';
    }

    function renderBundle() {
      var card = activeCard();
      var rows = cardRows(card);
      var ready = rows.length > 0;
      var total = 0;
      rows.forEach(function (row) {
        var v = rowVariant(row);
        if (!v || !v.available) ready = false;
        else total += v.price;
      });
      if (!atc) return;
      atc.disabled = !ready;
      atc.classList.toggle('is-added', state.added);
      if (!atcText) return;
      if (state.added) { atcText.textContent = atc.dataset.vtLabelAdded; return; }
      if (!ready) { atcText.textContent = bundle.getAttribute('data-vt-nosize') || atc.dataset.vtLabelNosize; return; }
      var paid = parseInt(card.getAttribute('data-vt-paid'), 10) || 1;
      if (rows.length > paid) {
        /* the automatic discount frees the cheapest pairs, so the customer pays for the dearest `paid` of them */
        var prices = rows.map(function (row) { return rowVariant(row).price; }).sort(function (a, b) { return b - a; });
        var payable = prices.slice(0, paid).reduce(function (a, b) { return a + b; }, 0);
        var save = total - payable;
        atcText.textContent = (bundle.getAttribute('data-vt-atc-2') || '').replace('[save]', money(save, data.moneyFormat));
      } else {
        atcText.textContent = atc.dataset.vtLabelAdd + ' · ' + money(total, data.moneyFormat);
      }
    }

    /* Countdown to the offer's real end date (the automatic discount's). At zero the
       page reloads once and the server renders it without the bundle. */
    var timer = bundle ? bundle.querySelector('[data-vt-deadline]') : null;
    if (timer) {
      var deadline = parseInt(timer.dataset.vtDeadline, 10) * 1000;
      var out = timer.querySelector('[data-vt-countdown]');
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var tick = function () {
        var left = Math.floor((deadline - Date.now()) / 1000);
        if (left <= 0) {
          clearInterval(tickId);
          out.textContent = '0s';
          try {
            if (!sessionStorage.getItem('vt-offer-ended')) {
              sessionStorage.setItem('vt-offer-ended', '1');
              location.reload();
            }
          } catch (e) {}
          return;
        }
        var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600);
        var m = Math.floor(left % 3600 / 60), s = left % 60;
        out.textContent = (d ? d + 'd ' : '') + pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
      };
      var tickId = setInterval(tick, 1000);
      tick();
    }

    if (bundle) {
      bundleCards.forEach(function (card) {
        var input = card.querySelector('.pdp-bundle-input');
        input.addEventListener('change', function () {
          if (!input.checked) return;
          /* carry pair #1 over, so switching offers never loses a choice */
          var prev = cardRows(activeCard())[0];
          var next = cardRows(card)[0];
          if (prev && next && prev !== next) {
            next.querySelector('[data-vt-pick-color]').value = prev.querySelector('[data-vt-pick-color]').value;
            syncSizes(next);
            next.querySelector('[data-vt-pick-size]').value = prev.querySelector('[data-vt-pick-size]').value;
            syncThumb(next);
          }
          bundleCards.forEach(function (c) { c.classList.toggle('is-active', c === card); });
          var lead = cardRows(card)[0];
          if (lead) state.color = lead.querySelector('[data-vt-pick-color]').value;
          state.added = false;
          render();
        });
        cardRows(card).forEach(function (row) {
          syncThumb(row);
          syncSizes(row);
          row.querySelector('[data-vt-pick-color]').addEventListener('change', function () {
            syncThumb(row);
            syncSizes(row);
            /* whichever pair was just recoloured is the one the shopper wants to see */
            if (card === activeCard()) state.color = this.value;
            state.added = false;
            render();
          });
          row.querySelector('[data-vt-pick-size]').addEventListener('change', function () {
            state.added = false;
            render();
          });
        });
      });
    }

    function render() {
      if (bundle) {
        applyGallery(state.color);
        applyBanner(state.color);
        renderBundle();
        return;
      }
      colorTiles.forEach(function (t) { t.classList.toggle('is-selected', t.dataset.vtColor === state.color); });
      applyGallery(state.color);
      applyBanner(state.color);
      if (colorNameEl) colorNameEl.textContent = state.color || '';

      /* a size the selected colour does not come in (or has sold out of) cannot stay selected */
      if (state.size !== null && data && data.variants) {
        var sv = pillVariant(state.size);
        if (!sv || !sv.available) state.size = null;
      }

      sizePills.forEach(function (p) {
        /* when the product carries a real gender option, show only that gender's sizes */
        var otherGender = !!p.dataset.vtSizeGender && p.dataset.vtSizeGender !== state.gender;
        if (p.dataset.vtSizeGender) p.hidden = otherGender;
        /* per colour: hide sizes that colour is not made in, strike through the sold-out ones */
        if (data && data.variants && data.sizeIndex >= 0) {
          var pv = pillVariant(p.dataset.vtSize);
          p.hidden = otherGender || !pv;
          var sold = !pv || !pv.available;
          p.classList.toggle('is-sold', sold);
          p.disabled = sold;
        }
        p.classList.toggle('is-selected', p.dataset.vtSize === state.size);
        if (!p.dataset.vtSizeGender) {
          var lbl = state.gender === 'Men' ? (p.dataset.vtLabelMen || p.dataset.vtLabelWomen) : p.dataset.vtLabelWomen;
          if (lbl) p.textContent = lbl;
        }
      });
      genderTabs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.vtGender === state.gender); });

      var v = currentVariant();
      if (idInput && v) idInput.value = v.id;
      if (priceEl && v) {
        priceEl.querySelector('[data-vt-price-now]').textContent = money(v.price, data.moneyFormat);
        var wasEl = priceEl.querySelector('[data-vt-price-was]');
        if (wasEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            wasEl.textContent = money(v.compare_at_price, data.moneyFormat); wasEl.hidden = false;
          } else { wasEl.hidden = true; }
        }
      }

      if (atc) {
        var needsSize = data && data.sizeIndex >= 0;
        var noSize = needsSize && state.size === null;
        var sold = v && !v.available;
        atc.disabled = noSize || !v || sold;
        atc.classList.toggle('is-added', state.added);
        if (atcText) {
          atcText.textContent = state.added ? atc.dataset.vtLabelAdded
            : noSize ? atc.dataset.vtLabelNosize
            : sold ? atc.dataset.vtLabelSold
            : atc.dataset.vtLabelAdd + (v ? ' · ' + money(v.price, data.moneyFormat) : '');
        }
      }
    }

    colorTiles.forEach(function (t) {
      t.addEventListener('click', function () { state.color = t.dataset.vtColor; state.added = false; render(); });
    });
    sizePills.forEach(function (p) {
      p.addEventListener('click', function () {
        if (p.classList.contains('is-sold')) return;
        state.size = p.dataset.vtSize; state.added = false; render();
      });
    });
    genderTabs.forEach(function (t) {
      t.addEventListener('click', function () {
        state.gender = t.dataset.vtGender;
        state.size = null;   /* sizes are per-gender — start over */
        state.added = false;
        render();
      });
    });

    /* accordions (mobile) */
    root.querySelectorAll('[data-vt-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = root.querySelector('#' + btn.getAttribute('aria-controls'));
        var open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var sign = btn.querySelector('.pdp-acc-sign');
        if (sign) sign.textContent = open ? '−' : '+';
      });
    });

    /* size guide trigger */
    root.querySelectorAll('[data-vt-sizeguide-open]').forEach(function (btn) {
      btn.addEventListener('click', function () { document.dispatchEvent(new CustomEvent('vantley:sizeguide:open')); });
    });

    /* add to cart */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var items = [];
        if (bundle) {
          /* one line per variant — two identical pairs become quantity 2 */
          cardRows(activeCard()).forEach(function (row) {
            var rv = rowVariant(row);
            if (!rv) return;
            var hit = items.filter(function (it) { return it.id === rv.id; })[0];
            if (hit) hit.quantity += 1; else items.push({ id: rv.id, quantity: 1 });
          });
        } else {
          var v = currentVariant();
          if (v) items.push({ id: v.id, quantity: 1 });
        }
        if (!items.length) return;
        atc.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            state.added = true; render();
            document.dispatchEvent(new CustomEvent('vantley:cart:added'));
            publishCartUpdate();
            setTimeout(function () { state.added = false; render(); }, 1800);
          })
          .catch(function () { form.submit(); });
      });
    }

    function publishCartUpdate() {
      /* the Vantley header drawer listens for vantley:cart:added and re-renders itself;
         this only keeps any other count bubble in the page honest. */
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      }).catch(function () {});
    }

    render();
  }

  /* ───────────── FAQ ───────────── */
  function initFaq(root) {
    if (root.dataset.vtInit) return;
    root.dataset.vtInit = '1';
    var items = Array.prototype.slice.call(root.querySelectorAll('.pdp-faq-item'));
    items.forEach(function (item, i) {
      var btn = item.querySelector('.pdp-faq-btn');
      var panel = item.querySelector('.pdp-faq-panel');
      var sign = item.querySelector('.pdp-faq-sign');
      btn.addEventListener('click', function () {
        var willOpen = !panel.classList.contains('is-open');
        items.forEach(function (other) {
          other.querySelector('.pdp-faq-panel').classList.remove('is-open');
          other.querySelector('.pdp-faq-sign').textContent = '+';
          other.querySelector('.pdp-faq-btn').setAttribute('aria-expanded', 'false');
        });
        if (willOpen) {
          panel.classList.add('is-open'); sign.textContent = '−';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
      if (i === 0) { panel.classList.add('is-open'); sign.textContent = '−'; btn.setAttribute('aria-expanded', 'true'); }
    });
  }

  /* ───────────── REVIEW PAGER ───────────── */
  function initReviews(root) {
    if (root.dataset.vtInit) return;
    root.dataset.vtInit = '1';
    var rows = Array.prototype.slice.call(root.querySelectorAll('.pdp-revrow'));
    var pager = root.querySelector('.pdp-pager');
    if (!rows.length || !pager) return;
    var mq = window.matchMedia(MOBILE);
    var page = 0;

    function perPage() { return mq.matches ? 5 : 9; }
    function pageCount() { return Math.max(1, Math.ceil(rows.length / perPage())); }

    function render() {
      var pp = perPage();
      if (page > pageCount() - 1) page = pageCount() - 1;
      rows.forEach(function (r, i) { r.hidden = !(i >= page * pp && i < page * pp + pp); });
      pager.hidden = rows.length <= pp;
      var nums = pager.querySelector('[data-vt-pagenums]');
      nums.innerHTML = '';
      for (var i = 0; i < pageCount(); i++) {
        (function (i) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'pdp-pagebtn' + (i === page ? ' is-active' : '');
          b.textContent = String(i + 1);
          b.addEventListener('click', function () { page = i; render(); });
          nums.appendChild(b);
        })(i);
      }
      pager.querySelector('[data-vt-prev]').disabled = page === 0;
      pager.querySelector('[data-vt-next]').disabled = page >= pageCount() - 1;
    }

    pager.querySelector('[data-vt-prev]').addEventListener('click', function () { page = Math.max(0, page - 1); render(); });
    pager.querySelector('[data-vt-next]').addEventListener('click', function () { page = Math.min(pageCount() - 1, page + 1); render(); });
    mq.addEventListener('change', function () { page = 0; render(); });
    render();
  }

  /* ───────────── SIZE GUIDE ───────────── */
  function initSizeGuide(root) {
    if (root.dataset.vtInit) return;
    root.dataset.vtInit = '1';
    var modal = root.querySelector('.vt-sg');
    if (!modal) return;

    function open() { modal.classList.add('is-open'); document.body.classList.add('vt-noscroll'); }
    function close() { modal.classList.remove('is-open'); document.body.classList.remove('vt-noscroll'); }
    document.addEventListener('vantley:sizeguide:open', open);
    modal.querySelectorAll('[data-vt-sg-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    var unit = 'in', group = modal.dataset.vtDefaultGroup || 'Adult';

    function render() {
      modal.querySelectorAll('[data-vt-unit]').forEach(function (t) { t.classList.toggle('is-active', t.dataset.vtUnit === unit); });
      modal.querySelectorAll('[data-vt-group]').forEach(function (t) { t.classList.toggle('is-active', t.dataset.vtGroup === group); });
      modal.querySelectorAll('[data-vt-row-group]').forEach(function (tr) {
        tr.hidden = tr.dataset.vtRowGroup !== group;
        var cell = tr.querySelector('[data-vt-len]');
        if (cell) cell.textContent = unit === 'in' ? cell.dataset.vtIn : cell.dataset.vtCm;
      });
    }
    modal.querySelectorAll('[data-vt-unit]').forEach(function (t) {
      t.addEventListener('click', function () { unit = t.dataset.vtUnit; render(); });
    });
    modal.querySelectorAll('[data-vt-group]').forEach(function (t) {
      t.addEventListener('click', function () { group = t.dataset.vtGroup; render(); });
    });
    render();
  }

  /* ───────────── SCROLL TO BUY ───────────── */
  if (window.__vantleyPdpBooted) return;
  window.__vantleyPdpBooted = true;

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-vt-scroll-buy]');
    if (!t) return;
    e.preventDefault();
    var el = document.querySelector('#buy');
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
  });

  function boot(scope) {
    (scope || document).querySelectorAll('[data-vt-buy]').forEach(initBuy);
    (scope || document).querySelectorAll('[data-vt-faq]').forEach(initFaq);
    (scope || document).querySelectorAll('[data-vt-reviews]').forEach(initReviews);
    (scope || document).querySelectorAll('[data-vt-sizeguide]').forEach(initSizeGuide);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  /* theme editor: re-init a section after it re-renders */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
